<template>
  <div>
    <div class="makbuz" id="Yazdir">
      <div class="header" v-html="data.Bilgi.Makbuz"></div>
      <hr v-if="data.Bilgi.Makbuz">
      <div class="Detay">
        <table class="table">
          <thead>
          <tr>
            <th>Son Ödeme Tarihi</th>
            <th>Borç Türü</th>
            <th>Açıklama</th>
            <th class="text-right">Tutar</th>
            <th class="text-right">Zam</th>
            <th class="text-right">Ödenen</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="Tahakkuk in data.Tahakkuk">
            <td>{{ Tahakkuk.tTarihi }}</td>
            <td>{{ Tahakkuk.Kategori }}</td>
            <td>{{ Tahakkuk.Aciklama }}</td>
            <td class="text-right">{{ Tahakkuk.Tutar }}</td>
            <td class="text-right">{{ Tahakkuk.ZamTutar }}</td>
            <td class="text-right">{{ Tahakkuk.Odenecek }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="3" class="text-right">MAKBUZ TOPLAMI</th>
            <th class="text-right">{{ data.T.T }}</th>
            <th class="text-right">{{ data.T.Z }}</th>
            <th class="text-right">{{ data.T.O }}</th>
          </tr>
          </tfoot>
        </table>
        <em v-if="data.Bilgi.Aciklama"><b>Makbuz Açıklama:</b> {{ data.Bilgi.Aciklama }}</em>
        <b v-if="data.Bilgi.BorcDurum">
          <hr class="m-1">
          <b>Güncel Borcunuz:</b> {{ data.Bilgi.Borc }} TL</b>
        <b v-if="!data.Bilgi.BorcDurum">
          <hr class="m-1">
          <i class="feather-thumbs-up"></i> Güncel borcunuz bulunmamaktadır. <br> <i class="feather-clock"></i>
          Ödemelerinizi düzenli yaptığınız için teşekkür ederiz.</b>
        <vrcode
          :value="data.Bilgi.Url"
          helpers="url"
          :options="{size: 100,level: 'L'}"
          logo="https://cdn.mudu.pro/Design/Qr.jpg"
        ></vrcode>
      </div>
      <div class="Bilgi">
        <table class="table">
          <thead>
          <tr>
            <th colspan="2" class="text-center">TAHSİLAT MAKBUZU</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Ad Soyad</td>
            <td class="text-right">{{ data.Bilgi.AdSoyad }}</td>
          </tr>
          <tr>
            <td>Bina Adı</td>
            <td class="text-right">{{ data.Bilgi.BinaAdi }}</td>
          </tr>
          <tr>
            <td>Mesken Bilgi</td>
            <td class="text-right">{{ data.Bilgi.Kat }}. Kat {{ data.Bilgi.kNo }} Numara</td>
          </tr>
          <tr>
            <td>Makbuz No</td>
            <td class="text-right">{{ data.Bilgi.mNo }}</td>
          </tr>
          <tr>
            <td>Kasa</td>
            <td class="text-right">{{ data.Bilgi.Kasa }}</td>
          </tr>
          <tr>
            <td>Ödeme Tarihi</td>
            <td class="text-right">{{ data.Bilgi.oTarihi }}</td>
          </tr>
          <tr>
            <td>İşlem Zamanı</td>
            <td class="text-right">{{ data.Bilgi.iTarihi }}</td>
          </tr>
          <tr v-if="data.Bilgi.KomisyonDurum">
            <td>Pos Komisyonu</td>
            <td class="text-right">{{ data.Bilgi.Komisyon }} TL</td>
          </tr>
          <tr v-if="data.Bilgi.tZamDurum">
            <td>Tahsil Zam</td>
            <td class="text-right">{{ data.Bilgi.tZam }} TL</td>
          </tr>
          <tr v-if="data.Bilgi.tmKarDurum">
            <td>Hizmet Bedeli</td>
            <td class="text-right">{{ data.Bilgi.tmKar }} TL</td>
          </tr>
          <tr v-if="data.Bilgi.EmanetDurum">
            <td>Emanet</td>
            <td class="text-right">{{ data.Bilgi.Emanet }} TL</td>
          </tr>
          <tr v-if="data.BankaDokum">
            <td>Banka Referans No</td>
            <td class="text-right">{{ data.BankaDokum.Referans }}</td>
          </tr>
          <tr>
            <td>Ödenen</td>
            <td class="text-right"><b>{{ data.Bilgi.OdemeTutar }} TL</b></td>
          </tr>
          </tbody>
        </table>
        <small>{{ data.Bilgi.BinaAdi }} adına {{ data.Bilgi.Personel.AdSoyad }} tarafından tahsil edilmiştir.</small>
      </div>
    </div>
    <div class="clearfix"></div>
    <hr>
    <div slot="footer" v-if="!IptalMakbuzu" class="dialog-footer text-center">
      <el-button v-if="this.$store.getters.Yetki.MakbuzIptal>0" type="danger" class="float-left" size="small"
                 @click="IptalEt()" icon="el-icon-error">
        İptal Et
      </el-button>
      <el-button type="success" v-if="data.Bilgi.Telefon" class="float-right" size="small" @click="SmsGonder()"
                 icon="feather-send">
        e-Makbuz'u Sms Gönder
      </el-button>
      <el-button type="primary" class="float-right" size="small" @click="Yazdir()" icon="feather-printer">
        A5 Yazdır
      </el-button>
      <el-button v-if="Termal" type="warning" class="float-right" size="small" @click="TermalYazdirma=true"
                 icon="feather-printer">
        Termal Yazdır
      </el-button>
      <div class="clearfix"></div>
    </div>
    <MakbuzYazdir :Logo="Logo" @close="Yazdirma=false" v-if="Yazdirma" :data="data" :FontSize="FontSize"></MakbuzYazdir>
    <TermalMakbuz :Logo="Logo" @close="TermalYazdirma=false" v-if="TermalYazdirma" :data="data"></TermalMakbuz>
  </div>
</template>

<script>

import MakbuzYazdir from "../../../Yazdir/MakbuzYazdir";
import TermalMakbuz from "../../../Yazdir/TermalMakbuz";

export default {
  components: {TermalMakbuz, MakbuzYazdir},
  props: ['data', 'IptalMakbuzu'],
  data() {
    return {
      IptalYetki: null,
      lo: true,
      Sms: null,
      Yazdirma: false,
      TermalYazdirma: false,
      FontSize: null,
      Logo: '',
      Termal: false
    }
  },
  methods: {

    Yazdir() {
      //window.print();
      this.Yazdirma = true;
    },
    IptalEt() {
      this.$confirm("Makbuzu iptal etmek istediğinize eminmisiniz?", this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil()
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil() {
      this.lo = true
      this.$store.dispatch("Delete", {...this.Form, path: 'MakbuzIptal/' + this.data.Bilgi.id})
        .then(response => {
          if (response.Durum == "OK") {
            this.$emit('MakbuzDetayModal', false);
            this.$message.success(response.Mesaj);
            this.lo = false
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
            this.lo = false
          }
        })

    },
    SmsGonder() {
      var Value = 'Sayın ' + this.data.Bilgi.AdSoyad + ', ' + this.data.Bilgi.mNo + ' nolu makbuzla ' + this.data.Bilgi.OdemeTutar + ' TL ödemeniz alınmıştır. E-Makbuz: ' + this.data.Bilgi.Url + ' - Ödemeniz için teşekkür ederiz. ';
      var Text = 'Telefon: ' + this.data.Bilgi.Telefon;
      this.$prompt(Text, 'Sms Metnini Onaylayınız', {
        confirmButtonText: 'Sms Gönder',
        cancelButtonText: 'Vazgeç',
        inputType: 'textarea',
        inputValue: Value,
      }).then(({value}) => {
        if (!value) {
          this.$message.error('Sms İçeriği boş olduğu için gönderilemedi');
        } else {
          this.SmsIlet(value);
          this.$message.info('Sms gönderiliyor');
        }

      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    SmsIlet(mesaj) {
      this.Sms = [{
        Telefon: this.data.Bilgi.Telefon,
        Icerik: mesaj,
        Kisi_id: this.data.Bilgi.Kisi_id,
        Bina_id: this.data.Bilgi.Bina_id,
        Mesken_id: this.data.Bilgi.Mesken_id
      }];
      this.$store.dispatch("Post", {
        ...this.Sms,
        path: 'iletisim/sms/gonder'
      })
        .then(response => {
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
          } else {
            this.$message.error(response.Mesaj);
          }
        })

    },

    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'spesiyal/fontsize'})
        .then(response => {
          this.FontSize = response.Font
          this.Termal = response.Termal
          this.Logo = response.Logo
        });
    }
  },
  created() {
    this.SayfaYukle();
    this.IptalYetki = this.$store.getters.Yetki.iptal;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Vezne/Makbuz/Tahsilat.vue